import React, { useEffect, useState } from "react";
import { Phone, ArrowRight, Heart } from "lucide-react";
import { heroSlides, company } from "../mock";

const Hero = () => {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % heroSlides.length), 6000);
    return () => clearInterval(t);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 78;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  const s = heroSlides[idx];

  return (
    <section id="home" className="relative h-[100svh] min-h-[620px] w-full overflow-hidden">
      {heroSlides.map((slide, i) => (
        <div key={i} className={`hero-slide ${i === idx ? "active" : ""}`}>
          <div className="hero-zoom" style={{ backgroundImage: `url(${slide.image})` }} />
        </div>
      ))}

      {/* overlay */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(100deg, rgba(10,31,77,0.90) 0%, rgba(20,53,126,0.72) 42%, rgba(20,53,126,0.20) 100%)",
        }}
      />

      <div className="relative z-10 h-full max-w-7xl mx-auto px-6 flex items-center">
        <div key={idx} className="hero-anim max-w-2xl text-white pt-16">
          <span className="eyebrow text-[#f2a25a]">{s.eyebrow}</span>
          <h1 className="font-display font-bold leading-[1.05] mt-5 text-[42px] sm:text-[58px] lg:text-[66px]">
            {s.title}
            <span className="block text-[#f2a25a]">{s.highlight}</span>
          </h1>
          <p className="mt-6 text-lg sm:text-xl text-white/85 max-w-xl">{s.text}</p>
          <div className="mt-9 flex flex-wrap items-center gap-4">
            <button
              onClick={() => scrollTo("contact")}
              className="btn-orange inline-flex items-center gap-2 px-8 py-4 rounded-full font-semibold text-[15px]"
            >
              Free Consultation <ArrowRight size={18} />
            </button>
            <a
              href={`tel:${company.phoneLink}`}
              className="btn-outline-white inline-flex items-center gap-2 px-8 py-4 rounded-full font-semibold text-[15px]"
            >
              <Phone size={18} /> {company.phone}
            </a>
          </div>
          <div className="mt-9 flex items-center gap-3 text-white/80">
            <Heart size={18} className="text-[#f2a25a] fill-[#f2a25a]" />
            <span className="font-script text-2xl text-white">{company.tagline}</span>
          </div>
        </div>
      </div>

      {/* slide dots */}
      <div className="absolute z-20 bottom-28 left-1/2 -translate-x-1/2 md:left-6 md:translate-x-0 flex gap-3">
        {heroSlides.map((_, i) => (
          <button
            key={i}
            onClick={() => setIdx(i)}
            className="h-2.5 rounded-full transition-all duration-300"
            style={{
              width: i === idx ? "34px" : "12px",
              background: i === idx ? "#e07c24" : "rgba(255,255,255,0.55)",
            }}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>

      {/* bottom wave */}
      <div className="wave-bottom z-10">
        <svg viewBox="0 0 1440 120" preserveAspectRatio="none" style={{ width: "100%", height: "90px" }}>
          <path fill="#ffffff" d="M0,64 C240,120 480,20 720,48 C960,76 1200,120 1440,72 L1440,120 L0,120 Z" />
        </svg>
      </div>
    </section>
  );
};

export default Hero;
